<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/networkSystem" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("system.label.CreateNetworkSystem") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.SystemCode')"
              >
                <vs-input
                  v-model="systemCode"
                  :label="$t('system.label.SystemCode')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.SystemName')"
              >
                <vs-input
                  v-model="systemName"
                  :label="$t('system.label.SystemName')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-checkbox
                class="mt-5 mb-5 font-semibold"
                v-model="isGroupSupported"
                >{{ $t("system.label.GroupSupported") }}</vs-checkbox
              >
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.ProvisioningSystem")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.ProvisioningSystem')"
                >
                  <v-select
                    label="item"
                    v-model="status"
                    :options="networkEleData.statusTypeEnumList"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createsystem"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("reports.label.configurations"), to: "" },
        {
          name: this.$t("system.label.NetworkSystem"),
          to: "/networkSystem",
        },
        {
          name: this.$t("system.label.CreateNetworkSystem"),
          to: "/",
        },
      ],
      networkEleData: {},
      systemCode: "",
      systemName: "",
      isGroupSupported: false,
      status: "",
      errorMessage: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {},
  methods: {
    async getTemplateData() {
      try {
        const response = await this.$store.dispatch(
          "provisioningConfig/getCreateNetworkElementTemplate"
        );
        this.networkEleData = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createsystem() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try{
      let payload = {
        systemcode: this.systemCode,
        systemname: this.systemName,
        status: this.status,
        isGroupSupported: this.isGroupSupported,
      };
      await this.$store.dispatch(
        "provisioningConfig/createNetworkElementAction",
        payload
      );
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Network System Created Successfully!",
        type: "success",
      });
      this.$router.push("/networkSystem");
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.systemCode = "";
      this.systemName = "";
      this.isGroupSupported = false;
      this.status = "";
      // Reset validation
      this.$refs.observer.reset();
    },
  },

  mounted() {
    this.getTemplateData();
  },
};
</script>
